export const initialAccountState = () => ({
  fetchAccountsLoading: false,
  fetchAccountsFailure: false,
  fetchAccountsLoaded: false,
  fetchRolesLoading: false,
  fetchRolesFailure: false,
  fetchRolesLoaded: false
});
